import { LangDropdown } from "@/modules/auth/components/LangDropdown";
import { ThemeSwitch } from "@/modules/auth/components/ThemeSwitch";
import { ColocaLogo } from "@/shared/components/ColocaLogo";
import useTranslations from "@/shared/lang/useTranslations";
import { useTheme } from "@/shared/theme/useTheme";

const LANGUAGES = [
  { label: "EN", value: "en" },
  { label: "ES", value: "es" },
  { label: "PT", value: "pt" },
];

/** Minimal header for the public link frame: logo + language switcher + theme toggle. No sidebar. */
export function PublicVerificationHeader() {
  const { theme, toggleTheme } = useTheme();
  const { activeLanguage, setLanguage } = useTranslations("verification");

  return (
    <header className="flex items-center justify-between px-4 py-4 sm:px-6">
      <div className="max-w-28 sm:max-w-32">
        <ColocaLogo variant={theme === "dark" ? "white" : "black"} />
      </div>
      <div className="flex items-center gap-2">
        <LangDropdown
          defaultSelected={activeLanguage}
          items={LANGUAGES}
          onChange={(value) => setLanguage(value)}
        />
        <ThemeSwitch theme={theme} toggleTheme={toggleTheme} />
      </div>
    </header>
  );
}
